module.exports = __webpack_public_path__ + "img/score_2.db9cbac0.png";